<template>
  <el-scrollbar style="width: 100%; height: 80vh;">
    <el-row v-if="blogTag" class="movie-list">
      <el-tag
        v-for="(tag,index) in dataList"
        :key="index"
        type="success"
        style="margin: 5px"
      >
        <router-link style="text-decoration-line: none" target="_blank" :to="`/blog/tag/post?name=` + tag.name">
          {{ tag.name }}
        </router-link>
      </el-tag>
    </el-row>
    <el-row v-else class="movie-list">
      <el-tag
        v-for="(tag,index) in dataList"
        :key="index"
        type="success"
        style="margin: 5px"
      >
        <router-link style="text-decoration-line: none" target="_blank" :to="`/blog/category/post?name=` + tag.name">
          {{ tag.name }}
        </router-link>
      </el-tag>
    </el-row>
  </el-scrollbar>
</template>

<script>
import {getCategory} from "@/api/blog";

export default {
  name: 'CategoryIndex',
  data() {
    return {
      queryInfo: {
        type: 'tag'
      },
      dataList: [],
      blogTag: false
    }
  },
  created() {
    const path = this.$route.path
    if (path !== undefined && path !== null) {
      if (path.endsWith('category')) {
        document.title = '文章分类'
        this.queryInfo.type = 'category'
        this.getData()
      } else if (path.endsWith('tag')) {
        document.title = '文章标签'
        this.queryInfo.type = 'tag'
        this.blogTag = true
        this.getData()
      }
    } else {
      document.title = 'BlogTag'
    }
  },
  methods: {
    getData() {
      getCategory(this.queryInfo).then(resp => {
        if (resp.code === 0) {
          this.dataList = resp.data
        } else {
          this.$message.error(resp.msg)
        }
      }).catch(error => {
        this.$message.error(error.message)
      })
    }
  }
}
</script>

<style scoped>
/*处于手机屏幕时*/
@media screen and (max-width: 768px) {
  .movie-list {
    padding: 5px;
  }
}

.movie-list {
  padding: 5px;
}

.tag{
  padding-top: 1px;
  padding-bottom: 1px;
  margin-left: 3px;
  margin-right: 3px;
}
</style>
